declare global {
  interface Window {
    fcWidget: any;
  }
}

export default {
  install(app: any) {
    if (typeof window === "undefined") return;
    const script = document.createElement("script");
    script.src = "https://wchat.freshchat.com/js/widget.js";
    script.async = true;
    script.onload = () => {
      window.fcWidget.init({
        token: process.env.FRESHCHAT_TOKEN,
        host: process.env.FRESHCHAT_HOST,
      });
    };
    document.head.appendChild(script);
  },
};
